export default __webpack_public_path__ + "static/char-s-02-kr-835c0527c934b73d34b2b094ee65ae67.webp";